<template>
  <div class="my-card">
        <div class="item1">
          <slot name="header"></slot>
        </div>
        <div class="item2">
          <slot name="content"></slot>
        </div>
  </div>
</template>
<script>
  export default {
    name: 'stats-card'
  }

</script>
<style scoped>
  .card-content {
  min-height: 85px;
}
.my-card {
  border-radius: 10px;
  padding: 1em 0px;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  background: white;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
  margin-bottom: 1em;
}
.simple .my-card {
  background: no-repeat;
  box-shadow: none;
  margin-bottom: 0em;
  padding: 0;
}
.simple .my-card .item2{
 display: none;
}
.simple .my-card .item1{
    background: white;
    padding: calc(0.5em / 2) 0.5em;
    border-radius: 50%;
    box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
}
.item1, .item2{
  flex: 1;
}

.icon-big{
  font-size: 1.4em;
  /* background: rgba(0, 0, 0, 0.03); */
  border-radius: 50%;
  padding: 0.1em;
}

.numbers{
      text-align: center;
      font-size: 1.4em;
      color:#f37024;
      font-weight: bold;
      margin-left: 0px;
}
.numbers p{
  margin: 0;
  font-size: 0.75em;
  color:rgba(0, 0, 0, 0.5);
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/StatsCard.vue